import { render, staticRenderFns } from "./CardSpecialCover.vue?vue&type=template&id=30b4c82a"
import script from "./CardSpecialCover.vue?vue&type=script&lang=js"
export * from "./CardSpecialCover.vue?vue&type=script&lang=js"
import style0 from "./CardSpecialCover.vue?vue&type=style&index=0&id=30b4c82a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports